<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mobileCheck } from "@/utils/mobile_check.js";
import { Device } from "@capacitor/device";

export default {
  mounted() {
    if (location.href.includes("bnb-stage-coach-deep.carrotglobal.com")) {
      if (mobileCheck(navigator.userAgent || navigator.vendor || window.opera)) {
        console.log("mobile");
        let varUA = navigator.userAgent.toLowerCase();
        if (varUA.match("android") != null) {
          console.log("android");
          window.location.href = "market://details?id=com.carrotenglish.ctest";
        } else if (varUA.indexOf("iphone") > -1 || varUA.indexOf("ipad") > -1 || varUA.indexOf("ipod") > -1) {
          console.log("ios");
          window.location.href = "https://apps.apple.com/us/app/spac/id1225076497";
        } else {
          alert("모바일에서만 제공됩니다");
          window.close();
        }
      } else {
        alert("모바일에서만 제공됩니다");
        window.close();
      }
    }
    this.startVersionCheck();
  },
  methods: {
    checkVersion(cur, min) {
      let curList = cur.split(".");
      let minList = min.split(".");
      let verStep = curList.length;
      if (verStep > minList.length) verStep = minList.length;

      let loopCnt = 0;
      let result = false;
      // 현재 버전이 최소버전보다 높다면 false 를 리턴한다.
      // Ture 라면 업데이트를 해야한다.

      curList.forEach((item) => {
        if (loopCnt < verStep) {
          if (Number(item) < Number(minList[loopCnt])) {
            result = true;
          }
        }
        loopCnt++;
      });
      return result;
    },

    async startVersionCheck() {
      let res = await axios.get("https://kr.object.ncloudstorage.com/apks/bnb/bnb-coach-appVersion.json", {});
      console.log("res", res.data.android);
      console.log("res", res.data.ios);

      const androidStore = "market://details?id=com.carrot.itm_my_class";
      const iosStore = "https://apps.apple.com/us/app/my-class/id6450909895";
      let result = false; // 버전 비교 결과값, true 인 경우 버전을 올려야만 한다.
      let storeURL = ""; // 스토어 주소를 저장하기 위한 값.
      let deviceVersion = ""; //앱 버전정보를 위한 값

      //디바이스 구분 정보를 가져오기 위함.
      let device = await Device.getInfo();
      console.log("device", device);
      //안드로이드나 IOS가 아니라면 이후 프로세스를 진행하지 않는다.
      if (device.platform == "android" || device.platform == "ios") {
        //앱의 버전 정보를 가져오기 위함.
        let app = await App.getInfo();
        console.log("app", app);
        deviceVersion = app.version;

        if (device.platform == "android") {
          //안드로이드 인 경우
          result = checkVersion(deviceVersion, res.data.android);
          storeURL = androidStore;
        } else if (device.platform == "ios") {
          //아이폰인 경우
          result = checkVersion(deviceVersion, res.data.ios);
          storeURL = iosStore;
        }
        if (result) {
          if (
            confirm(`필수 업데이트가 있습니다.
    App 최신 기능 사용을 위해 업데이트를 하시겠습니까?`)
          ) {
            window.open(storeURL);
            //앱을 종료시키는 코드를 넣는다.
            app.exitApp();
          } else {
            //앱을 종료시키는 코드를 넣는다.
            app.exitApp();
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import "src/assets/style/reset.scss";
@import "src/assets/style/common.scss";
@import "src/assets/style/style.scss";
</style>
